module.exports = __webpack_public_path__ + "img/DE00802.af546a17.png";